export const columns = (self) => {
    return [
        {
            prop: 'icon',
            label: '产品信息',
            width: '280',
            tooltip: true,
            render: (h, params) => {
                let row = params.row;
                return h('div', {
                    style: {
                        display: 'flex',
                        alignItem: 'center',
                    }
                }, [
                    h('img', {
                        attrs: {
                            src: params.row.icon,
                            width: '64',
                            height: '64',
                        },
                        style:{
                            borderRadius:"10px"
                        }
                    }),
                    h('div',{
                        style:{
                            marginLeft:'20px'
                        }
                    },[
                        h('h3',{
                            style:{
                                color: '#333',
                            }
                        },row.productName),
                        h('p',{
                            style:{
                                color: '#797D7E',
                            }
                        },`${row.customName} | ${row.productModel}`),
                        h('p',{
                            style:{
                                color: '#797D7E',
                            }
                        },`产品ID：${row.pId}`)
                    ])
                ]);
            }
        },
        {
            label: '产品id',
            prop: 'pId',
            tooltip: true
        },
        {
            label: '产品名称',
            prop: 'productName',
            tooltip: true
        },
        {
            label: '自定义名称',
            width: 180,
            align: "center",
            headerAlign: "center",
            tooltip: true,
            prop: 'customName',
        },
        {
            label: '设备类型',
            prop: 'deviceType',
            align: "center",
            headerAlign: "center",
            render: (h, params) => {
                let txt = '';
                if(params.row.deviceType == 0){
                    txt = '普通设备'
                }else if(params.row.deviceType == 1){
                    txt = '网关设备'
                }else if(params.row.deviceType == 2){
                    txt = '子设备'
                }
                return h('div',{},txt)
            }
        },
        {
            label: '设备模型',
            prop: 'networkType',
            align: "center",
            headerAlign: "center",
            render: (h, params) => {
                let txtObj = {
                    '-1':'其他',
                    0:'WIFI',
                    1:'NB',
                    2:'4G',
                    3:'LoRa',
                    4:'ZigBee',
                    5:'蓝牙'
                  }
                  let txt = '';
                  txt = txtObj[params.row.networkType]
                  return h('div',{},txt)
            }
        },
         
        {
            label: '备注',
            width: 150,
            align: "center",
            headerAlign: "center",
            prop: 'remark',
        },
        {
            label: '创建时间',
            width: 150,
            align: "center",
            headerAlign: "center",
            prop: 'createTime'
        },
        {
            label: '操作',
            width: 200,
            align: "center",
            headerAlign: "center",
            fixed: "right",
            render: (h, params) => {
                const look = (h) => {
                    return h('el-link', {
                        props: {
                            type: 'primary',
                            underline: false
                        },
                        style: {

                        },
                        on: {
                            click: () => {
                                self.showOperateBtn(0, params.row);
                            }
                        }
                    }, '继续开发');
                };

                const edit = (h) => {
                    return h('el-link', {
                        props: {
                            type: 'primary',
                            underline: false
                        },
                        style: {

                        },
                        on: {
                            click: () => {
                                self.showOperateBtn(1, params.row);
                            }
                        }
                    }, '编辑');
                };
                const del = (h) => {
                    return h('el-link', {
                        props: {
                            type: 'primary',
                            underline: false
                        },
                        style: {

                        },
                        on: {
                            click: () => {
                                self.showOperateBtn(2, params.row);
                            }
                        }
                    }, '删除');
                };

                const editStandard = (h) => {
                    return h('el-link', {
                        props: {
                            type: 'primary',
                            underline: false
                        },
                        style: {

                        },
                        on: {
                            click: () => {
                                self.showOperateBtn(3, params.row);
                            }
                        }
                    }, '改为标准');
                };

                const buttons = [];
                // ,del(h)
                buttons.push(look(h), edit(h))
                if(!params.row.isStandardModel){
                    buttons.push(editStandard(h));
                }
                return h('div', {
                    class: "common-space-around"
                }, buttons);
            }
        }
    ]
}